
$(document).ready(function(){
  
  $('.promo_banner .close').click(function() {
      $('.promo_banner').addClass('promo_banner-close')
    });
 
  
/*  var $header = $('.header');
  var $slider = $('.slideshow');
  var $slideri = $('.slideshows .owl-item');
  var $window = $(window).on('resize', function(){
    var height = $(this).height() - $header.height();
    $slider.height(height);
    $slideri.height(height);
  }).trigger('resize'); //on page load*/
  



});